import { Card, Group, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { ComponentProps, Fragment, memo } from "react";

import { Plate } from "@/components/@custom/Plate";
import { ExpeditionDate } from "@/features/expedicao/components/ExpeditionDate";
import { cn } from "@/utils/cn";
import { omitClassNameFromProps } from "@/utils/omit";

interface ExpeditionQueueListItemBaseProps {
  driverName: string;
  components?: {
    DateCard?: React.ReactNode;
    Actions?: React.ReactNode;
    DriverInfo?: React.ReactNode;
    Bottom?: React.ReactNode;
  };
  slots: {
    DriverInfoWrapper?: ComponentProps<"div">;
    Actions?: ComponentProps<"div">;
    Wrapper?: Card.Props;
    Plate: ComponentProps<typeof Plate>;
    ExpeditionDate: ComponentProps<typeof ExpeditionDate>;
    DriverWrapper?: ComponentProps<"div">;
  };
}

export const ExpeditionQueueListItemBase = memo(({ driverName, slots, components }: ExpeditionQueueListItemBaseProps) => {
  const isMobile = useMediaQuery("(max-width: 640px)");
  const hasBottom = !!components?.Bottom;

  return (
    <Card orientation={isMobile ? "vertical" : "horizontal"} shadow="sm" withBorder>
      <Card.Section p="xs" withBorder>
        <div className={cn("flex flex-1 items-center gap-2", slots?.DriverWrapper?.className)} {...omitClassNameFromProps(slots?.DriverWrapper ?? {})}>
          {!components?.DateCard && <ExpeditionDate {...slots?.ExpeditionDate} />}
          {components?.DateCard}
        </div>
      </Card.Section>

      <Card.Section flex={1} p="xs">
        <div className="flex h-full items-center justify-center gap-2">
          <div className="flex flex-1 flex-col items-center justify-between gap-2 sm:flex-row">
            <div className={cn("max-xs:flex-col flex gap-2", { "flex-col": hasBottom })}>
              <Group component={!hasBottom ? Fragment : "div"}>
                <Plate {...slots?.Plate} slots={{ wrapper: { className: cn("w-full max-w-44") } }} />
                {hasBottom && (
                  <Text fw="bold" size="md" c="gray.7">
                    {driverName}
                  </Text>
                )}
              </Group>

              <div
                className={cn("flex flex-col justify-center gap-2 text-sm leading-none text-gray-700", slots?.DriverInfoWrapper?.className)}
                {...omitClassNameFromProps(slots?.DriverInfoWrapper ?? {})}
              >
                {!hasBottom && (
                  <Text fw="bold" size="sm" c="gray.7">
                    {driverName}
                  </Text>
                )}
                {components?.DriverInfo}
              </div>

              {components?.Bottom}
            </div>

            {components?.Actions && (
              <div className="flex gap-1" {...slots?.Actions}>
                {components.Actions}
              </div>
            )}
          </div>
        </div>
      </Card.Section>
    </Card>
  );
});
ExpeditionQueueListItemBase.displayName = "ExpeditionQueueListItemBase";
